import {
  LayoutDashboard,
  Calendar,
  Users,
  Scissors,
  DollarSign,
  Settings,
  Car,
  FileText,
  Wrench,
  PawPrint,
  Sparkles,
  type LucideIcon,
} from "lucide-react";
import type { Vertical } from "@/lib/types";

export interface NavigationItem {
  name: string;
  href: string;
  icon: LucideIcon;
}

export interface VerticalBranding {
  appName: string;
  subtitle: string;
  logoInitial: string;
  searchPlaceholder: string;
  entityLabels: {
    client: string;
    clientPlural: string;
    service: string;
    servicePlural: string;
    appointment: string;
  };
}

export interface VerticalConfig {
  id: Vertical;
  branding: VerticalBranding;
  navigation: NavigationItem[];
  dashboard: { component: string };
}

const verticalConfigs: Record<Vertical, VerticalConfig> = {
  HEALTHCARE: {
    id: "HEALTHCARE",
    branding: {
      appName: "Derma Essence",
      subtitle: "Gestão de Clínicas",
      logoInitial: "D",
      searchPlaceholder: "Buscar pacientes, agendamentos...",
      entityLabels: {
        client: "Paciente",
        clientPlural: "Pacientes",
        service: "Procedimento",
        servicePlural: "Procedimentos",
        appointment: "Agendamento",
      },
    },
    navigation: [
      { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
      { name: "Agenda", href: "/agenda", icon: Calendar },
      { name: "Pacientes", href: "/pacientes", icon: Users },
      { name: "Procedimentos", href: "/procedimentos", icon: Scissors },
      { name: "Financeiro", href: "/financeiro", icon: DollarSign },
      { name: "Configurações", href: "/configuracoes", icon: Settings },
    ],
    dashboard: { component: "healthcare" },
  },
  AUTOMOTIVE: {
    id: "AUTOMOTIVE",
    branding: {
      appName: "Auto Essence",
      subtitle: "Gestão de Oficinas",
      logoInitial: "A",
      searchPlaceholder: "Buscar veículos, orçamentos...",
      entityLabels: {
        client: "Cliente",
        clientPlural: "Clientes",
        service: "Serviço",
        servicePlural: "Serviços",
        appointment: "Ordem de Serviço",
      },
    },
    navigation: [
      { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
      { name: "Veículos", href: "/veiculos", icon: Car },
      { name: "Orçamentos", href: "/orcamentos", icon: FileText },
      { name: "Clientes", href: "/pacientes", icon: Users },
      { name: "Financeiro", href: "/financeiro", icon: DollarSign },
      { name: "Configurações", href: "/configuracoes", icon: Settings },
    ],
    dashboard: { component: "automotive" },
  },
  BEAUTY: {
    id: "BEAUTY",
    branding: {
      appName: "Beauty Essence",
      subtitle: "Gestão de Salões",
      logoInitial: "B",
      searchPlaceholder: "Buscar clientes, agendamentos...",
      entityLabels: {
        client: "Cliente",
        clientPlural: "Clientes",
        service: "Serviço",
        servicePlural: "Serviços",
        appointment: "Agendamento",
      },
    },
    navigation: [
      { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
      { name: "Agenda", href: "/agenda", icon: Calendar },
      { name: "Clientes", href: "/pacientes", icon: Users },
      { name: "Serviços", href: "/procedimentos", icon: Sparkles },
      { name: "Financeiro", href: "/financeiro", icon: DollarSign },
      { name: "Configurações", href: "/configuracoes", icon: Settings },
    ],
    dashboard: { component: "healthcare" },
  },
  PETCARE: {
    id: "PETCARE",
    branding: {
      appName: "Pet Essence",
      subtitle: "Gestão Pet",
      logoInitial: "P",
      searchPlaceholder: "Buscar pets, tutores...",
      entityLabels: {
        client: "Tutor",
        clientPlural: "Tutores",
        service: "Serviço",
        servicePlural: "Serviços",
        appointment: "Agendamento",
      },
    },
    navigation: [
      { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
      { name: "Agenda", href: "/agenda", icon: Calendar },
      { name: "Tutores", href: "/pacientes", icon: Users },
      { name: "Serviços", href: "/procedimentos", icon: PawPrint },
      { name: "Financeiro", href: "/financeiro", icon: DollarSign },
      { name: "Configurações", href: "/configuracoes", icon: Settings },
    ],
    dashboard: { component: "healthcare" },
  },
  GENERIC: {
    id: "GENERIC",
    branding: {
      appName: "Essence",
      subtitle: "Gestão de Negócios",
      logoInitial: "E",
      searchPlaceholder: "Buscar clientes, serviços...",
      entityLabels: {
        client: "Cliente",
        clientPlural: "Clientes",
        service: "Serviço",
        servicePlural: "Serviços",
        appointment: "Agendamento",
      },
    },
    navigation: [
      { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
      { name: "Agenda", href: "/agenda", icon: Calendar },
      { name: "Clientes", href: "/pacientes", icon: Users },
      { name: "Serviços", href: "/procedimentos", icon: Wrench },
      { name: "Financeiro", href: "/financeiro", icon: DollarSign },
      { name: "Configurações", href: "/configuracoes", icon: Settings },
    ],
    dashboard: { component: "healthcare" },
  },
};

export function getVerticalConfig(vertical: Vertical): VerticalConfig {
  return verticalConfigs[vertical] || verticalConfigs.GENERIC;
}
